import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext';
import MainLayout from './layouts/MainLayout';
import PublicLayout from './layouts/PublicLayout';
import ProtectedRoute from './components/ProtectedRoute';
import { Toaster } from './components/ui/toaster';
import './i18n'; // Inicializar i18n

import LessorList from './pages/LessorList';
import LessorCreate from './pages/LessorCreate';
import LessorDetail from './pages/LessorDetail';
import LessorEdit from './pages/LessorEdit';
import VehicleList from './pages/VehicleList';
import VehicleForm from './pages/VehicleForm';
import VehicleDetail from './pages/VehicleDetail';
import VehicleEdit from './pages/VehicleEdit';
import VehicleSearch from './pages/VehicleSearch';
import VexsoftConfig from './pages/VexsoftConfig';
import BuyerList from './pages/BuyerList';
import BuyerForm from './pages/BuyerForm';
import BuyerDetail from './pages/BuyerDetail';
import BuyerEdit from './pages/BuyerEdit';
import KanbanBoard from './pages/KanbanBoard';
import WhatsAppManager from './pages/WhatsAppManager';
import ContactList from './pages/ContactList';
import UsersPage from './pages/UsersPage';
import RentlyConfigPage from './pages/RentlyConfigPage';
import LoginPage from './pages/LoginPage';

// Páginas públicas de catálogo
import CatalogoPage from './pages/CatalogoPage';
import CatalogoDetailPage from './pages/CatalogoDetailPage';
import SobrePage from './pages/SobrePage';

// Criar instância do QueryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Suspense fallback={<div>Carregando...</div>}>
          <BrowserRouter>
            <Routes>
            {/* Página de login */}
            <Route path="/login" element={<LoginPage />} />

            {/* Rotas públicas de catálogo (sem login) */}
            <Route path="/" element={
              <PublicLayout>
                <CatalogoPage />
              </PublicLayout>
            } />
            <Route path="/catalogo" element={
              <PublicLayout>
                <CatalogoPage />
              </PublicLayout>
            } />
            <Route path="/catalogo/:id" element={
              <PublicLayout>
                <CatalogoDetailPage />
              </PublicLayout>
            } />
            <Route path="/sobre" element={
              <PublicLayout>
                <SobrePage />
              </PublicLayout>
            } />

            {/* Rotas administrativas (backoffice) - protegidas com autenticação */}
            <Route path="/admin/*" element={
              <ProtectedRoute>
                <MainLayout>
                  <Routes>
                    <Route path="locadoras" element={<LessorList />} />
                    <Route path="locadoras/create" element={<LessorCreate />} />
                    <Route path="locadoras/:id" element={<LessorDetail />} />
                    <Route path="locadoras/:id/edit" element={<LessorEdit />} />
                    
                    <Route path="veiculos" element={<VehicleList />} />
                    <Route path="veiculos/create" element={<VehicleForm />} />
                    <Route path="veiculos/search" element={<VehicleSearch />} />
                    <Route path="veiculos/vexsoft-config" element={<VexsoftConfig />} />
                    <Route path="veiculos/:id" element={<VehicleDetail />} />
                    <Route path="veiculos/:id/edit" element={<VehicleEdit />} />

                    <Route path="compradores" element={<BuyerList />} />
                    <Route path="compradores/create" element={<BuyerForm />} />
                    <Route path="compradores/:id" element={<BuyerDetail />} />
                    <Route path="compradores/:id/edit" element={<BuyerEdit />} />

                    <Route path="whatsapp" element={<WhatsAppManager />} />
                    <Route path="kanban" element={<KanbanBoard />} />
                    <Route path="contatos" element={<ContactList />} />
                    <Route path="usuarios" element={<UsersPage />} />
                    <Route path="users" element={<Navigate to="/admin/usuarios" replace />} />
                    <Route path="configuracoes/rently" element={<RentlyConfigPage />} />

                    {/* Redirect to vehicle list by default */}
                    <Route path="" element={<VehicleList />} />
                  </Routes>
                </MainLayout>
              </ProtectedRoute>
            } />
          </Routes>
          <Toaster />
        </BrowserRouter>
        </Suspense>
      </AuthProvider>
    </QueryClientProvider>
  );
}